<template>
  <v-layout row wrap justify-center align-center no-gutters>
    <pagoPSE class="pos-pagoPSE"/>
    <v-flex xs12 class="mt-3 mb-6">
      <secModulos />
    </v-flex>
    <v-flex xs12 class="mt-4">
      <secTransacciones />
    </v-flex>
    <v-flex xs12>
      <secNoticias />
    </v-flex>
    <v-flex xs12 sm6>
      <secActualizado />
    </v-flex>
     <v-flex xs12 sm6>
      <secAlianzas />
    </v-flex>
    <v-flex xs12 sm10 md8 class="mt-4">
      <secLogosPatrocinio/>
    </v-flex>
    <v-flex xs12>
      <secContacto/>
    </v-flex>
  </v-layout>
</template>

<script>
import secModulos from '../components/sec-modulos'
import secTransacciones from '../components/sec-transacciones'
import secNoticias from '../components/sec-noticias'
import secActualizado from '../components/sec-estaractualizado'
import secAlianzas from '../components/sec-alianzas'
import secLogosPatrocinio from '../components/sec-logospatrocinio'
import pagoPSE from '../components/pago-pse.vue'
import secContacto from '../components/sec-contacto'

export default {
  components: {
    secModulos,
    secTransacciones,
    secNoticias,
    secActualizado,
    secAlianzas,
    secLogosPatrocinio,
    pagoPSE,
    secContacto
  },
  metaInfo: {
    meta: [
      { charset: 'utf-8' },
      { name: 'inicio', content: 'Página de inicio EAAV' },
      { name: 'keywords', content: 'acueducto, EAAV, villavicencio, agua villavicencio, alcantarillado, ' },
      { property: 'og:title', content: 'EAAV | Estamos para servirte' },
      { property: 'og:description', content: 'Empresa de Acueducto y Alcantarillado de Villavicencio' },
      { property: 'og:type', content: 'website' },
      { property: 'og:site_name',
        content: 'Servicios: Información general y contacto para los ciudadanos' },
      // { property: 'og:url', content: document.location.href },
      { property: 'og:image', content: './simbol.png' }
    ]
  }
}
</script>
<style lang="scss" scoped>
.contenedor{
  height: auto;
}
.pos-pagoPSE{
  position: fixed;
  right: 0px;
  top: 65vh;
  z-index: 1;
}
</style>
